import {
  EmailValidation,
  EmailValidationPayload,
  SocialRegistrationPayload,
  SocialRegistration,
  PackageInfo,
} from './interfaces';
import { usePost, useFetch } from '@selfserve/react-hooks';

import { apiEndpoints } from '@selfserve/react-utils';

export const useEmailValidationRequest = () =>
  usePost<EmailValidationPayload, EmailValidation>(
    apiEndpoints.emailValidation
  );

export const useSocialRegistrationRequest = () =>
  usePost<SocialRegistrationPayload, SocialRegistration>(apiEndpoints.socialIdentification);

export const usePackageInfoRequest = (desiredPackageId: string) => {
  const url = apiEndpoints.packageInfo.replace(':id', desiredPackageId);

  return useFetch<PackageInfo>(url, undefined, {
    enabled: !!url,
  });
};

export * from './interfaces';
export * from './schemas';
